<template>  
  <div id="app">
    <div class="page-freeUser py-3">
      <div class="row">
        <div class="col-12 pt-1" align="left">
          <router-link to="/">  
            <b-button variant="light">
              &lt;&lt;&lt;--- Volver atras
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-12 col-xl-12">           
            <div class="cont-freeUser-text d-flex flex-column justify-content-around mt-5 mt-md-5">
              <div class="cont-title">
                <p class="title-1 mb-0">¡Bienvenido a tu Virtual Partner!</p>
                <p class="title-1 mb-0"><b>{{this.name}}</b></p>
                <p
                  class="desc mt-5 pr-0 pr-md-5"
                >Selecciona una solicitud para ver su detalle</p>
              </div>
              <div v-if="loading" id="loader"></div>
              <div v-else>
              <!-- .cont-title -->                
                <b-table
                  id="my-table"
                  :items="filas" 
                  :fields="campos"
                  :current-page="currentPage"
                  :per-page="perPage"
                  hover                    
                  @row-clicked="selected">                  
                  
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="center"
                ></b-pagination>                

                <!--router-link to="/">  
                  <button class="button1">
                      <img class="img1" src="@/assets/images/icons/exitWhite.svg">
                    Volver
                  </button>
                </router-link-->
              </div>
              <div class="footer1">
                <p class="p1">Powered</p>
                <img align="right" src="@/assets/images/icons/logo-dp.svg" alt="logo dp" />
              </div>
              <div>
                <b-modal 
                  ref="my-modal" 
                  hide-footer
                  centered
                  title="Atención al mensaje:"
                  no-close-on-backdrop
                  @hidden="hideModal">
                  <div class="d-block text-center">
                    <h3>{{this.msjModal}}</h3>
                  </div>
                  <b-button class="mt-3" variant="outline-danger"
                    block 
                    @click="hideModal">
                      Cerrar
                  </b-button>
                </b-modal>
              </div>
            </div>            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
export default {
  name: "FreeUser",
  components: {},
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      name: "",
      img1: 'circle-clock.svg',
      img2: 'circle-clock.svg',
      msjModal: '',
      flagPath: 0,
      campos: [ 
        { key: 'idSol', label:'ID de la solicitud', class: 'text-left'  }, 
        { key: 'fechaSol', label: 'Fecha de la solicitud', class: 'text-center'   }, 
        { key: 'fechaPer', label: 'Fechas del permiso', class: 'text-center'  }, 
        { key: 'estado', label: 'Estado de la solicitud', class: 'text-center'  },
        { key: 'tiquetes', label: 'Tiquetes', class: 'text-center'  }
      ],
      filas: [],
      perPage: 5,
      currentPage: 1,
      idUser: '',
    };
  },
  beforeMount() {    
    this.actGetRequestsFree({cc: this.$route.params.cc}).then(() =>{
          if(this.requestsFree.data){
            this.idUser = this.requestsFree.data[0].core_employee.id;
            for(let i=this.requestsFree.data.length-1; i >= 0; i--){    
              if(this.requestsFree.data[i].status == 'closed'){
                this.filas.push({
                  "idSol": this.requestsFree.data[i].license_id,
                  "fechaSol": this.requestsFree.data[i].date.substring(0,10),
                  "fechaPer": this.requestsFree.data[i].license_dates,
                  "estado": (this.requestsFree.data[i].status=="closed") ? "Cerrado": "Pendiente",
                  "tiquetes": (this.requestsFree.data[i].tickets == 1) ? 'Solicitados':'No'
                });
              }
            }
            this.name = this.requestsFree.data[0].core_employee.name;
          }
          else{
            this.name = "No existen solicitudes asociadas al numero de cedula: "+this.$route.params.cc;
          }
        }).catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message = "No se pudo conectar al servicio: "+response;
        });
  },
  computed: {    
    ...mapState("modRequest",["requestsFree","loading"]),

    rows() {
        return this.filas.length
      }
  },
  methods: {
    ...mapActions("modRequest", [
      "actGetRequestsFree",
    ]),
    selected(record) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')      
      //this.$router.push({ path: '/details/:recordId' }) {{}}
      //alert(this.idUser)
      if(record.estado == 'Cerrado'){
        this.$router.push({ path: '/inforequest/'+record.idSol+'/'+this.$route.params.cc+'/'+this.idUser })
      }
      else{
        this.showModal("Esta solicitud aún está en proceso, no se puede visualizar.",0);        
      }
    },
    showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },
    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/solicitudes' });
        }
     },
  },
  
};
</script>

<style lang="scss">
  .cont-freeUser-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 32px;
      }
      .title-2 {
        font-weight: bold;
        font-size: 34px;
        line-height: 36px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-freeUser {
      .form-group {
        label {
          position: absolute;
          color: #454545;
          font-size: 12px;
          background-color: #ffffff;
          padding: 4px;
          top: -16px;
          left: 10px;
        }
        input[type="text"] {
          height: 36px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
      button {
        background: #269887;
        color: #ffffff;
        border-radius: 50px;
        height: 36px;
        font-size: 16px;

        &:hover {
          background: darken(#269887, 5);
        }
      }
    }
    .footer1 {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #1C3A4E;
    color: white;
    text-align: right;
  }
  .p1{
    font-family: "Poppins";
    color: #FFFFFF;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    //text-align: right;
  }
  .button1 {
    background: #1C3A4E;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    width: 70;    
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #1C3A4E;
    border-color: #1C3A4E;  
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 530px
  }
  .img1 {
    width: 18px;
    height: 18px;    
    left: 100%;
    top: 100%;     
    float: center;    
  }
  .centerImg1 {
    width: 16px;
    height: 16px;    
    top: 100%;     
    float: right;    
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 } 
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom { 
    from{ bottom:-100px; opacity:0 } 
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
} 
</style>